<div
    class="loader-spinner"
    role="status"
    [attr.aria-label]="label()"
    [style.--loader-size]="loaderSize()"
    [style.--spinner-top-color]="spinnerColor()"
    [style.--spinner-base-color]="baseColor()"
    [style.--spinner-border-size]="borderSize()"
>
    <span class="loader-spinner__sr-only">{{ label() }}</span>
</div>